module.exports = __webpack_public_path__ + "img/downa.302eaf10.png";